<template>
  <g-page-wrapper>
    <template slot="pageTitle">

      <div v-if="'PA' === userInfo.auth">
        <g-page-title :title="$t('pages_user_CustomerList.path')"></g-page-title>
      </div>
      <div v-else >
        <g-page-title :title="$t('pages_user_CustomerList.customer.path')"></g-page-title>
      </div>

    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-wrapper-between -mb-3" v-if="isCreateButton">
          <div class="-wrapper-stretch">
            <template >
              <g-button variant="primary" id="customer-list-add" @click="onClickAddCount">
                <g-icon name="add"></g-icon>
                <span>{{$t('pages_user_CustomerList.add_account')}}</span>
              </g-button><!--
              --><g-button variant="primary" id="customer-list-portal-add" @click="onClickAddCustomerPortalCount">
                <g-icon name="add"></g-icon>
                <span>{{$t('pages_user_CustomerList.add_customer_portal_account')}}</span>
              </g-button>
            </template>
          </div>
        </div>

        <div class="-tile-container -bg-white">
          <div class="-wrapper-tile h-v-center-">
            <div class="-tile-container -wrapper-stretch fitting-">
              <div class="-wrapper-stretch h-v-center- -pl-1" style="max-width: 200px;" v-if="isAdmin">
                <g-dropdown
                  id="customer-list-auth"
                  dropdown-type="button"
                  variant="secondary"
                  class="-width-100"
                  v-model="groupKey">
                  <g-dropdown-item-wrap>
                    <g-dropdown-item
                      v-for="group in authGroupList"
                      :key="group.key"
                      :text="group.name"
                      :value="group.key"
                    />
                  </g-dropdown-item-wrap>
                </g-dropdown>
              </div>
              <div class="-wrapper-stretch h-v-center-">
                <g-search-bar
                  id="customer-list-grid-searchbar"
                  no-border
                  full
                  placeholder="Search anything"
                  style="width: calc(100% - 30px);"
                  v-model="searchText" />
                <g-button
                  id="customer-list-grid-excel-download"
                  variant="borderless"
                  size="small"
                  icon-only
                  class="-mr-0 -minus-ml-2"
                  @click="onClickDownload">
                  <g-icon name="get_app"  width="16px" height="16px" color="gray-1" />
                </g-button>
              </div>
            </div>
          </div>
          <ag-grid-vue
            id="customer-list-grid"
            class="ag-theme-balham"
            style="height: 500px;"
            row-height="30"
            header-height="30"
            ref="agGrid"
            :modules="modules"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="customerList"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :loadingOverlayComponentParams="loadingOverlayComponentParams"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
            :frameworkComponents="frameworkComponents"
            :paginationPageSize="paging.size"
            :pagination="true"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @grid-ready="onGridReady"
            @row-clicked="rowClicked"
            @row-data-changed="onRowDataChanged"
            @pagination-changed="paginationChanged">
          </ag-grid-vue>
          <g-pagenation
            id="customer-list-grid-paging"
            class="-py-6 -pr-2"
            :page-no="paging.pageNo == 0 ? 1 : paging.pageNo"
            :page-size-list="pageSizeList"
            :page-size="paging.size"
            :total-count="paging.totalCount"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
/*
BMM : jihee.kim@bespinglobal.com
AM : ripple31@nate.com
BS : may.kim@bespinglobal.com
BM : boyoung.lee@bespinglobal.com
*/

import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import { DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE, LOCALE, AUTH_GROUP} from "@/constants/constants";
import AgGridMixin from '../../mixin/AgGrid.mixin'
import TagCell from '../../components/ag-grid/TagCell'
import CodeList from '@/code/CodeList'

export default {
  name: 'customer-user-list',
  componentName: 'CustomerUserList',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  data () {
    return {
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      paging : {
        pageNo : 1,
        size : DEFAULT_PAGE_SIZE,
        startIndex : 0,
        totalCount : 0,
      },
      columnDefs: [],
      searchText: '',
      groupKey: ''
    }
  },
  computed: {
    ...mapGetters('customer', [
      'codeCustomerList',
      'groupList',
      'customerList'
    ]),
    ...mapGetters('user', ['userInfo']),
    isCreateButton () {
      if (this.userInfo.auth === AUTH_GROUP.BespinAdmin) {
        return true
      }
      return false
    },
    authGroupList () {
      return this.groupList
    },
    isProductManager () {
      return this.userInfo.auth === AUTH_GROUP.BespinProductManager
    },
    isSales () {
      return this.userInfo.auth === AUTH_GROUP.BespinSales
    },
    isAdmin () {
      return this.userInfo.auth === AUTH_GROUP.BespinAdmin
    }
  },
  methods: {
    ...mapActions('customer', [
      'getCustomerList'
    ]),
    setColumn () {
      if(this.userInfo.auth === AUTH_GROUP.BespinAdmin ){
        this.columnDefs = [
          {
            field: 'customerName',
            headerName: this.$t('pages_user_CustomerList.header.customerName'),
            unSortIcon: true,
            filter: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'customerDeptName',
            headerName: this.$t('pages_user_CustomerList.header.customerDeptName'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}

          }, {
            field: 'userName',
            headerName: this.$t('common.manager_name'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'userEmail',
            headerName: this.$t('pages_user_CustomerList.header.userEmail'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'userTelNo',
            headerName: this.$t('pages_user_CustomerList.header.userTelNo'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          }, {
            field: 'lastLoginDate',
            headerName: this.$t('pages_user_CustomerList.header.lastLoginDate'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'auth',
            headerName: this.$t('common.auth'),
            cellRenderer: (params) => {
              const group = this.groupList.find(item => item.id === params.value) || {}
              if (this.locale === LOCALE.KOREAN) {
                return group.nameKo
              }
              return group.nameEn
            },
            unSortIcon: true,
            sortable: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'useYn',
            headerName: this.$t('pages_user_CustomerList.header.status'),
            sortable: true,
            unSortIcon: true,
            cellRendererFramework: TagCell((params) => {
              let text = ''
              let color = ''
              if (params.value === 'Y') {
                text = this.$t('pages_user_CustomerList.row.active')
                color = 'green-'
              } else if (params.value === 'N') {
                text = this.$t('pages_user_CustomerList.row.deactive')
                color = 'gray-'
              } else if (params.value === 'D') {
                text = this.$t('pages_user_CustomerList.row.withdraw')
                color = 'red-'
              }
              return {
                text, color
              }
            }),
            cellStyle : {"cursor":"pointer"},
          },
        ]
      }else{

        this.columnDefs = [
          {
            field: 'customerName',
            headerName: this.$t('pages_user_CustomerList.header.customerName'),
            unSortIcon: true,
            filter: true,
          }, {
            field: 'customerDeptName',
            headerName: this.$t('pages_user_CustomerList.header.customerDeptName'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userName',
            headerName: this.$t('common.manager_name'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userEmail',
            headerName: this.$t('pages_user_CustomerList.header.userEmail'),
            sortable: true,
            unSortIcon: true,
          }, {
            field: 'userTelNo',
            headerName: this.$t('pages_user_CustomerList.header.userTelNo'),
            sortable: true,
            unSortIcon: true,
            cellStyle : {"cursor":"pointer"}
          },
          {
            field: 'duty',
            headerName: this.$t('pages_user_CustomerList.row.duty'),
            sortable: true,
            unSortIcon: true,
            width: 70,
          },{
            field: 'isPortalYn',
            headerName: this.$t('pages_user_CustomerList.row.isPortalYn'),
            sortable: true,
            unSortIcon: true,
          },



        ]
      }
    },
    onGridReady(params) {
      this.setGridParams(params)
      this.fitGrid()
    },
    onRowDataChanged (e) {
      if (this.codeCustomerList === CodeList.READY) {
        this.noRowsOverlayComponentParams.exception = false
        this.gridApi.showLoadingOverlay()
      } else if (this.codeCustomerList === CodeList.EXCEPTION) {
        this.noRowsOverlayComponentParams.exception = true
        this.gridApi.showNoRowsOverlay()
      } else if (this.codeCustomerList === CodeList.SUCCESS) {
        if (this.customerList.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }

      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
      this.fitGrid()
    },
    rowClicked (e) {

      if (this.isAdmin) {
        this.$router.push(`/user/info?userid=${e.data.userId}`)
      }
    },
    paginationChanged (e) {
      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
    },
    onClickAddCount () {
      this.$router.push('/user/create')
    },
    onClickAddCustomerPortalCount () {
      this.$router.push('/user/customer_portal_create')
    },
    onChangePageNo (pageNo) {
      this.paging.pageNo = pageNo;
      this.gridApi.paginationGoToPage(pageNo - 1);
    },
    onChangePageSize (pageSize) {
      this.paging.size = pageSize;
      this.paging.pageNo = 1;
      this.gridApi.paginationSetPageSize(this.paging.size);
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
    },
    onClickDownload () {
      const startIndex = 0
      const endIndex =this.gridApi.getDisplayedRowCount()

      let params ={}
      if(this.userInfo.auth === AUTH_GROUP.BespinAdmin ) {
         params = {
          fileName: 'accounts',
          allColumns: false,
          columnKeys: ['customerName', 'customerDeptName', 'userName', 'userEmail', 'userTelNo', 'lastLoginDate', 'auth'],
          shouldRowBeSkipped(params) {
            const {node} = params
            if (node.rowIndex >= startIndex && node.rowIndex < endIndex) {
              return false
            }
            return true
          }
        }
      }else{
        params = {
          fileName: 'accounts',
          allColumns: false,
          columnKeys: ['customerName', 'customerDeptName', 'userName', 'userEmail', 'userTelNo', 'lastLoginDate', 'auth','duty','isPortalYn'],
          shouldRowBeSkipped(params) {
            const {node} = params
            if (node.rowIndex >= startIndex && node.rowIndex < endIndex) {
              return false
            }
            return true
          }
        }
      }

      this.gridApi.exportDataAsCsv(params);
    }
  },
  watch: {
    searchText () {
      this.gridOptions.api.setQuickFilter(this.searchText)
      this.paging.pageNo = 1;
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
    },
    groupKey () {
      this.getCustomerList()
      this.gridApi.showLoadingOverlay()
    }
  },
  beforeMount () {

    if(this.userInfo.auth === AUTH_GROUP.AccountManager){
      this.$showToast(this.$t('pages_contract_ContractDetail.no.auth'))
      this.$popupManager.close(this.instKey)
      this.$router.push("/")
    }
    this.defaultColDef.sortable = true
    this.defaultColDef.filter = false

    if (this.groupList.length === 1) {
      this.groupKey = this.groupList[0].key
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/user/components/CustomerUserList.vue